var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Huge-icon/arrows/solid/direction-down 01"
  }, /*#__PURE__*/React.createElement("g", {
    id: "direaction down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 175 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.34535 7.94308C5.56098 7.67355 5.95429 7.62985 6.22383 7.84548L10.0001 10.8665L13.7763 7.84548C14.0458 7.62985 14.4391 7.67355 14.6548 7.94308C14.8704 8.21262 14.8267 8.60593 14.5572 8.82156L10.3905 12.1549C10.1622 12.3375 9.83789 12.3375 9.60963 12.1549L5.44296 8.82156C5.17342 8.60593 5.12972 8.21262 5.34535 7.94308Z",
    fill: "#1C0054"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirection);
export default __webpack_public_path__ + "static/media/direction.0b189137f5ec841e2edc86ac31636315.svg";
export { ForwardRef as ReactComponent };